import React, { ReactElement } from 'react'
import { TermLink, TermLinkProps } from '../TermLink'
import { useTranslation } from '../../utils/convergence'
import { useIsCashApp, useUkRegFlags } from '../../state'
import { DesignLanguage, useIsDesignLanguage } from '@afterpaytouch/core'

interface UseSignUpTermsResult {
  readonly [tagName: string]: ReactElement<TermLinkProps>
}

export const useTermsKey = (): string => {
  const isCashApp = useIsCashApp()
  const { isUkCreditCheckEnabled, isUkRegulationEnabled } = useUkRegFlags()
  if (isUkCreditCheckEnabled) {
    return isUkRegulationEnabled ? 'signUp:terms_creditCheck_ukRegulation' : 'signUp:terms_creditCheck'
  }
  if (isCashApp) {
    return 'signUp:cash_terms'
  }
  return 'signUp:terms'
}

export const useSignUpTerms = (): UseSignUpTermsResult => {
  const { t } = useTranslation()
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const linkColor = isArcadeDesignLanguage ? 'Black' : 'Orca'

  return {
    cashapplink: <TermLink key='payment-options-cash-app' color={linkColor} href={t('common:cashAppPrivacyPolicyUrl')} fontFace='CashSansMono' />,
    terms: <TermLink key='sign-up-terms-of-service' href={t('common:termsOfServiceUrl')} color={linkColor} fontFace='CashSansMono' />,
    consent: <TermLink key='payment-options-consent' color={linkColor} href={`${t('common:termsOfServiceUrl')}#e-sign`} fontFace='CashSansMono' />,
    privacy: <TermLink key='sign-up-privacy-policy' href={t('common:privacyPolicyUrl')} color={linkColor} fontFace='CashSansMono' />,
    optOut: <TermLink key='sign-up-opt-out' href={t('common:marketingOptOutUrl')} fontFace='CashSansMono' />,
    creditcheck: <TermLink key='sign-up-credit-check' href={t('common:creditCheckUrl')} color={linkColor} fontFace='CashSansMono' />,
  }
}
